import React from 'react';
import cx from 'classnames';

import styles from '../LoadingSpinner/LoadingSpinner.module.scss';

export interface LoadingSpinnerNoBitsProps {
  /** Custom className to override or add styles. */
  className?: Parameters<typeof cx>[0];
  spinnerClassName?: Parameters<typeof cx>[0];
  variant?: 'single-color' | undefined;
}

export const LoadingSpinnerNoBits: React.FC<LoadingSpinnerNoBitsProps> = ({
  className,
  spinnerClassName,
  variant,
}) => {
  return (
    <div
      className={cx(styles.loader, className)}
      aria-live='polite'
      aria-busy='true'
    >
      <svg
        className={cx(styles.spinner, spinnerClassName)}
        width='48px'
        height='48px'
        viewBox='0 0 48 48'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle
          className={cx(
            styles.path,
            variant === 'single-color' && styles.pathSingleColor,
          )}
          fill='none'
          strokeWidth='2'
          strokeLinecap='round'
          cx='24'
          cy='24'
          r='22'
        />
      </svg>
    </div>
  );
};

LoadingSpinnerNoBits.displayName = 'LoadingSpinnerNoBits';
export default LoadingSpinnerNoBits;
export { styles };
